<template>
  <div class="row" v-loading="loading">
    <div class="col-lg-4 col-md-5">
      <stand-card :info="info">

      </stand-card>
      <contacts-card :contacts="info.contacts">

      </contacts-card>
    </div>
    <div class="col-lg-8 col-md-7">
      <materials-card :materials="info.materials" @reload-content="reloadContent" v-on="$listeners">

      </materials-card>
    </div>
  </div>
</template>
<script>
  import MaterialsCard from './Widgets/MaterialsCard.vue'
  import StandCard from './Widgets/StandCard.vue'
  import info from './demo-stand-1.json'
  import ContactsCard from './Widgets/ContactsCard.vue'
  import {mapState} from 'vuex'

  export default {
    mounted () {
      this.$route.meta.title = `Стенд: ${this.info.title}`
    },
    components: {
      MaterialsCard,
      StandCard,
      ContactsCard
      // MembersCard
    },
    props: {
      standId: {
        type: Number,
        default () {
          return parseInt(this.$route.params.standId)
        }
      }
    },
    beforeRouteEnter: (to, from, next) => {
      next(vm => {
        if (to.params.standId) {
          vm.loadRecord(vm.standId)
        }
      })
    },
    beforeRouteUpdate: (to, from, next) => {
      next(vm => {
        if (to.params.standId) {
          vm.loadRecord(vm.standId)
        }
      })
    },
    breadcrumb () {
      return {
        label: this.info ? this.info.name : this.$gettext("Stand details"),
        parent: {
          name: 'stands-index'
        }
      }
    },
    // beforeRouteEnter (to, from, next) {
    //   next(vm => {
    //     let params = to.params
    //     if (params.standInfo === undefined || params.standInfo.id !== params.standId) {
    //       vm.$http.get(`stands/${params.standId}/`).then(result => {
    //         params.standInfo = result.data
    //         vm.$route.meta.breadcrumb = result.data.name
    //       })
    //     }
    //     // экземпляр компонента доступен как `vm`
    //   })
    // },
    computed: {
      baseApi () {
        return `/stands/stand/`
      },
      ...mapState({
        currentEvent: state => state.events.current,
        // available: state => state.events.available
      }),
    },
    mounted () {
      if (this.standId && this.info.id === undefined) {
        this.loadRecord(this.standId)
      }
    },
    data () {
      return {
        loading: false,
        info: {
          name: '',
          materials: [],
          description: "",
          contacts: []
        }
      }
    },
    methods: {
      async loadRecord (id) {
        this.loading = true
        const result = await this.$http.get(`${this.baseApi}${id}/`)
        this.info = result.data
        // this.updateModel(result.data)
        this.loading = false
        return result.data
      },
      async reloadContent () {
        await this.loadRecord(this.standId)
      }
    }
  }

</script>
<style>

</style>
